import React from 'react';
import styles from './Container.module.scss';

export const Container = React.memo(({ children }) => (
  <div className={styles.container}>{children}</div>
));
